import { defineComponent as _defineComponent } from 'vue'
import { ChatActionItem } from '@/modules/Chat/interfaces/ChatActionItem';

interface Props {
    chatActionItem: ChatActionItem;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatAction',
  props: {
    chatActionItem: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})